import { Select } from 'components/ui';
import { useVendor } from 'features/vendor';

/** Human-readable name for a shop profile. */
export function shopDisplayName(profile) {
  return profile?.displayName || profile?.businessName || 'Shop';
}

/**
 * Returns a `lookup(vendorId) -> shopName` function for the owner's shops.
 * Used to label which shop a staff member / bank account belongs to.
 */
export function useShopName() {
  const { shops } = useVendor();
  return (vendorId) => {
    if (!vendorId) return '';
    const match = shops.find((shop) => shop.profile?.id === vendorId)?.profile;
    return match ? shopDisplayName(match) : '';
  };
}

/**
 * Dropdown to choose a target shop. Renders nothing when the owner has a single
 * shop (callers default the value to the active shop in that case).
 */
export function ShopSelect({ value, onChange, label = 'Shop', required }) {
  const { shops } = useVendor();
  if (!shops || shops.length <= 1) return null;

  const options = shops.map((shop) => {
    const profile = shop.profile || {};
    const location = profile.city ? ` · ${profile.city}` : '';
    return { value: profile.id, label: `${shopDisplayName(profile)}${location}` };
  });

  return (
    <Select
      label={label}
      required={required}
      placeholder="Select a shop"
      options={options}
      value={value || ''}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}

export default ShopSelect;
